import "react-app-polyfill/ie9";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import { ThemeProvider } from "styled-components";
import App from "./components/App";
import ErrorBoundary from "./components/ErrorBoundary";
import history from "./history";
import store from "./store";
import { initMonitoring } from "./monitoring";

import { STYLES, GlobalFonts, GlobalStyle } from "./styles/_utilities";
import "./index.scss";

initMonitoring();

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={STYLES}>
      <ErrorBoundary>
        <App history={history} />
      </ErrorBoundary>
      <GlobalFonts />
      <GlobalStyle />
    </ThemeProvider>
  </Provider>,
  document.getElementById("app-root")
);

// O loader do Eldorado Bridge fica fora do bundle de entrada: é carregado em paralelo
// logo depois do primeiro render e os custom elements são definidos quando ele chega.
import("@meios-pagamentos/eldorado-bridge-component/loader").then(
  ({ applyPolyfills, defineCustomElements }) =>
    applyPolyfills().then(() => {
      defineCustomElements();
    })
);
